import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 's1-input-switch',
  templateUrl: './s1-input-switch.component.html',
  styleUrls: ['./s1-input-switch.component.scss']
})
export class S1InputSwitch {

  @Input() control: FormControl;
  @Input() label: string = '';
  @Input() set readonly(newValue: boolean) { // https://github.com/angular/angular/issues/48350

    if (newValue) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }

  };

  Validators = Validators;
  
  constructor() { }

}
